<template>
  <span class="updown">
    <i
      class="fas fa-caret-up"
      :class="sort.mode === me && sort.dir === 1 ? 'active' : ''"
      @click="$emit('dir', { mode: me, dir: 1 })"
    ></i
    ><i
      class="fas fa-caret-down"
      :class="sort.mode === me && sort.dir === 0 ? 'active' : ''"
      @click="$emit('dir', { mode: me, dir: 0 })"
    ></i
  ></span>
</template>
<script>
export default {
  name: "updown",
  props: {
    sort: {},
    me: {}
  }
};
</script>
<style lang="scss">
.updown {
  position: relative;
  top: -3px;
  display: inline-flex;
  flex-direction: column;

  i {
    height: 8px;
    color: grey;
    cursor: pointer;

    &:hover {
      color: black;
    }

    &.active {
      color: orangered;
    }
  }
}
</style>
